import React from 'react'
import { components, useTranslation } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import UaeMpciKeys from 'src/constants/locale/key/UaeMpci'
import { Box, IconButton, Tooltip, Table, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const {
  button: { CngButton }
} = components

function ConsignmentDetailsTable(props) {
  const { data, onAddConsignmentDetails, onEditConsignmentDetails, onDeleteConsignmentDetails, showNotification } = props
  const { translate } = useTranslation(Namespace.UAE_MPCI)

  const locationIdentificationType = translate(Namespace.UAE_MPCI, UaeMpciKeys.ConsignmentDetails.LOCATION_IDENTIFICATION_TYPE)
  const consignmentLocation = translate(Namespace.UAE_MPCI, UaeMpciKeys.ConsignmentDetails.CONSIGNMENT_LOCATION)
  const consignmentLocationName = translate(Namespace.UAE_MPCI, UaeMpciKeys.ConsignmentDetails.CONSIGNMENT_LOCATION_NAME)
  const paymentArrangementCode = translate(Namespace.UAE_MPCI, UaeMpciKeys.ConsignmentDetails.PAYMENT_ARRANGEMENT_CODE)

  return (
    <Box>
      <Box display="flex" justifyContent="flex-end" mb={1}>
        <CngButton
          color='primary'
          onClick={onAddConsignmentDetails}
          size='small'
          startIcon={<FontAwesomeIcon icon={['fal', 'plus']} />}
        >
          Add Consignment
        </CngButton>
      </Box>
      {data && data.length > 0 && (
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>{locationIdentificationType}</TableCell>
              <TableCell>{consignmentLocation}</TableCell>
              <TableCell>{consignmentLocationName}</TableCell>
              <TableCell>{paymentArrangementCode}</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((item, index) => (
              <TableRow key={index}>
                <TableCell>{item.locationIdentificationType}</TableCell>
                <TableCell>{item.consignmentLocation}</TableCell>
                <TableCell>{item.consignmentLocationName}</TableCell>
                <TableCell>{item.paymentArrangementCode}</TableCell>
                <TableCell align="right">
                  <Tooltip title="Edit">
                    <IconButton size="small" onClick={() => onEditConsignmentDetails(item)}>
                      <FontAwesomeIcon icon={['fal', 'pen']} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete">
                    <IconButton size="small" onClick={() => onDeleteConsignmentDetails(item)}>
                      <FontAwesomeIcon icon={['fal', 'trash']} />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </Box>
  )
}

export default ConsignmentDetailsTable
